import { ContentType, Method } from "axios-mapper";
import https from "../utils/https";

// lastWeek=false: this week real time estimate, lastWeek=true: last week settlement
export const getWeeklySalaryOverview = (lastWeek) => {
  return https().request("/affiliate-weekly-salary/overview", Method.GET, { lastWeek }, ContentType.form);
};

export const getWeeklySalaryRules = () => {
  return https().request("/affiliate-weekly-salary/rules", Method.GET);
};
